"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressValidation = void 0;
class AddressValidation {
    static validatePostcode(postcode) {
        const reg = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i;
        return reg.test(postcode);
    }
    static validateHouseNumber(housenumber) {
        const reg = /^\d+$/;
        return reg.test(housenumber);
    }
}
exports.AddressValidation = AddressValidation;
